import { AlertTriangle, Settings2 } from 'lucide-react';

// Influence-arrow indicator for tactical/optimal. Arrows are the senior direction at
// each coupling of the current run; markers/counter depend on the status. See
// db_client/strategies/classes/mtms/influence_arrows.py.

const STATUS_TITLE = {
  reset: 'Обнулено',
  no_influence: 'Нет влияния',
  conjugacy: 'Сопряженность',
  supercycle: 'Суперцикл',
  broken: '123 (сопряжённость нарушена)',
  combo_swap: 'Смена комбо',
  limit: 'Лимит ×3',
  config_error: 'Ошибка настройки цикла',
};

export const influenceBadgeVisible = (state) => Boolean(state?.status) && (
  !['supercycle', 'combo_swap', 'limit'].includes(state.status)
    ? !(state.status === 'conjugacy' && state.claim)
    : Boolean(state.sc_visible)
);

const InfluenceArrowsBadge = ({ state, preview = false }) => {
  if (!state || !state.status) return null;
  if (!preview && !influenceBadgeVisible(state)) return null;

  const { status, arrows: rawArrows = [], counter = 0 } = state;
  // Ordinary Coupling keeps its latest arrow. SC candidates are hidden above;
  // manual editor previews still use the same arrow layout.
  const arrows = status === 'conjugacy' ? rawArrows.slice(-1) : rawArrows;
  const hasArrows = arrows.length > 0;
  const showDanger = status === 'broken' || status === 'no_influence' || status === 'limit';
  const showConfig = status === 'config_error';
  const showSwap = status === 'combo_swap';
  // ×1 is shown as soon as the supercycle is reached (counter initialises immediately).
  const showCounter = status === 'supercycle' && counter >= 1;
  const showLimit = status === 'limit';

  return (
    <span
      className="inline-flex items-center gap-0.5 rounded-md border border-olive-200 bg-white/70 px-1.5 py-0.5 leading-none"
      title={STATUS_TITLE[status] || status}
    >
      {hasArrows ? (
        arrows.map((dir, i) => (
          <span
            key={i}
            className={`text-[13px] ${dir === 'up' ? 'text-emerald-600' : 'text-red-500'}`}
          >
            {dir === 'up' ? '▲' : '▼'}
          </span>
        ))
      ) : (
        <span className="text-[13px] text-olive-400">{status === 'reset' ? '■' : '▲'}</span>
      )}

      {(showCounter || showLimit) && (
        <span className="ml-0.5 rounded border border-sky-400 bg-sky-50 px-1 text-[9px] font-bold text-sky-600">
          ×{showLimit ? 3 : counter}
        </span>
      )}
      {showSwap && <span className="ml-0.5 text-[12px] font-bold text-sky-600">⇄</span>}
      {showDanger && <AlertTriangle className="ml-0.5 h-3 w-3 animate-pulse text-red-500" />}
      {showConfig && <Settings2 className="ml-0.5 h-3 w-3 animate-pulse text-amber-500" />}
    </span>
  );
};

export default InfluenceArrowsBadge;
